<template>
    <div class="modal" :class="{ 'is-open': open }">
        <div class="modal-box dark">
            <div class="modal-box-header">
                <span class="title">Szabadság</span>
                <button type="button" @click="$emit('close')" class="btn btn-plain btn-plain-wicon">
                    <md-icon>close</md-icon>
                </button>
            </div>

            <div class="modal-box-body">
                <span class="label">Szabadság beállítása</span>
                <span class="label">A szabadság dátumok használata jelenleg csak a Reklamációknál releváns!</span>

                <div class="input-col">
                    <label class="text-input-label" for="user_id">Helyettesítő</label>
                    <custom-select
                        id="user_id"
                        :selectedItem="selectedUser"
                        :large="true"
                        :options="users"
                        @changed="changeUser">
                    </custom-select>
                </div>

                <div class="input-col" style="margin-top: 30px">
                    <div class="input-wrapper" :class="{'error' : validation.from}">
                        <label class="text-input-label" for="address-data-form">Szabadság ettől</label>
                        <custom-datepicker
                            :init-date="leave_from"
                            format="YYYY-MM-DD"
                            :enable-passed-dates="false"
                            @changed="(el) => {leave_from = el}"
                        />
                        <span class="input-error">{{ validation.from }}</span>
                    </div>
                </div>

                <div class="input-col" style="margin-top: 30px; margin-bottom: 30px">
                    <div class="input-wrapper" :class="{'error' : validation.to}">
                        <label class="text-input-label" for="address-data-form">Szabadság eddig</label>
                        <custom-datepicker
                            :init-date="leave_to"
                            format="YYYY-MM-DD"
                            :enable-passed-dates="false"
                            @changed="(el) => {leave_to = el}"
                        />
                        <span class="input-error">{{ validation.to }}</span>
                    </div>
                </div>

                <button class="btn btn-primary button-submit" type="button" @click="submit">
                    {{ $t('settings.button.save') }}
                </button>
                <button class="btn btn-plain" type="button" @click="$emit('close')">
                    {{ $t('settings.button.cancel') }}
                </button>
            </div>
        </div>

        <div class="modal-layer"></div>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {MdIcon} from 'vue-material/dist/components'
import VTooltip from 'v-tooltip'

import config from '../../plugins/config.js'
import axios from 'axios'

import ModalConfirmation from '../../components/modals/ModalConfirmation.vue'
import CustomDatepicker from "@/components/dropdowns/CustomDatepicker.vue";
import CustomSelect from "@/components/dropdowns/CustomSelect.vue";

Vue.use(MdIcon)
Vue.use(VTooltip)

export default {
    name: 'ModalLeave',
    components: {CustomSelect, CustomDatepicker},
    props: ['open'],

    data() {
        return {
            leave_from: null,
            leave_to: null,
            users: [],
            selectedUser: null,
            validation: {},
        }
    },

    mounted() {
        this.$store.dispatch('FETCH_CURRENT_USER').then(() => {
            this.leave_from = this.profile.leave_from ?? null
            this.leave_to = this.profile.leave_to ?? null
            this.selectedUser = this.profile.temporaryUser ?? null
        })
        this.fetchUsers()
    },

    watch: {
        'open': function () {
            // this.leave_from = this.profile.leave_from ?? null
            // this.leave_to = this.profile.leave_to ?? null
        }
    },

    methods: {
        async fetchUsers() {
            const response = await axios.get('complaints/fetch-customer-service-users', config.AXIOS_DEFAULTS)
            this.users = response.users
        },
        async changeUser(user) {
            this.selectedUser = user
        },
        submit() {
            let data = {
                from: this.leave_from,
                to: this.leave_to,
                user_id: this.selectedUser?.id ?? null
            }

            return axios.post('user-leave', data, config.AXIOS_DEFAULTS)
                .then(data => {
                    let successMessage = [this.$t('settings.notification')]
                    this.$store.commit('setNotification', successMessage)

                    if (data) {
                        console.log(data)
                        this.leave_to = data.leave_to
                        this.leave_from = data.leave_from
                    }

                    this.$emit('close')
                })
                .catch(err => {
                    console.error(err)
                    this.validation = err.errors
                    this.$store.commit('setNotification', ['Sikertelen mentés'])
                })
        },
    },

    computed: {
        ...mapGetters(['profile']),
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/toolkit.scss';
@import '../../assets/sass/ui/input.scss';
@import '../../assets/sass/ui/button.scss';
@import '../../assets/sass/ui/modal.scss';

.modal {
    &-box {

        @media only screen and (max-width: 600px) {
            width: 95% !important;
        }

        &-body {
            .label {
                font-size: 15px;
                display: block;
                font-weight: 500;
                margin-top: 10px;
                margin-bottom: 25px;

                &.label-prices {
                    margin-top: 35px;
                }
            }

            .toggle {
                display: block;
                margin-bottom: 15px;
            }

            .button-group {
                margin-bottom: 35px;

                .label {
                    display: inline-block;
                    font-size: 13px;
                    margin-right: 10px;
                }

                .btn {
                    &:nth-child(2) {
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                        margin-right: -3px;
                    }

                    &:nth-child(3) {
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                    }
                }
            }

            .privacy-box {
                margin-bottom: 30px;

                .md-icon {
                    position: relative;
                    top: 4px;
                    font-size: 20px !important;
                }

                .button-privacy {
                    display: inline-block;
                    margin: 6px 0 0 29px;
                }
            }

            .button-submit {
                margin-right: 15px;
            }
        }
    }
}
</style>
<style lang="scss">
.tooltip-privacy {
    &::before,
    &::after {
        display: none;
    }
}
</style>
